import{getDefaultExportFromCjs as r}from"../../_virtual/_commonjsHelpers.js";import{_ as o}from"./_basePick.js";import{_ as s}from"./_flatRest.js";var t=o,a=r(s((function(r,o){return null==r?{}:t(r,o)})));export{a as default};
